module.exports = __webpack_public_path__ + "img/ryno-logo-white.971d2e12.svg";